import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { queryClient } from '@as-react/common-queries';
import { GLOSSARY_HIGHLIGHT_CLASS, initHighlightGlossaryItems, uniqueId } from '@as-react/common-utils';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Tooltip } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useBloomreachTracking } from '../../hooks/useBloomreachTracking';
import { useGlossary } from '../../hooks/useGlossary';
import { useOAuth } from '../../hooks/useOAuth';
import { useTealiumCustomerIdentification } from '../../hooks/useTealiumCustomerIdentification';
import { useZitcha } from '../../hooks/useZitcha';
import { HtmlInclude } from '../common/html-include/HtmlInclude';
const Bootstrap = () => {
    const { collectPageview } = useZitcha();
    const [highlightedItems, setHighlightedItems] = useState();
    useOAuth();
    useBloomreachTracking(true);
    useTealiumCustomerIdentification();
    useGlossary();
    useEffect(() => {
        collectPageview();
        setTimeout(() => {
            setHighlightedItems(initHighlightGlossaryItems(`.${GLOSSARY_HIGHLIGHT_CLASS}`));
        }, 2000);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(ReactQueryDevtools, { client: queryClient }), highlightedItems === null || highlightedItems === void 0 ? void 0 : highlightedItems.map(({ element, glossaryItem }, index) => (_jsx(Tooltip, { targetElement: element, title: glossaryItem.title, text: _jsx(HtmlInclude, { htmlFragment: glossaryItem.description }) }, `${glossaryItem.title}-${uniqueId()}-${index}`)))] }));
};
export default Bootstrap;
